
function handleCollectiveDownloadPage() {
    // init the button add event listener for the download request
    downloadButtonInit();
    handleEventsOnSelectAllCheckboxes();
}

function handleEventsOnSelectAllCheckboxes() {
    // get the select all checkboxes
    let checkboxEls = document.querySelectorAll("input[id$='-select-all']");
    for (let checkboxEl of checkboxEls) {
        checkboxEl.addEventListener('click', event => {
            let reportId = checkboxEl.getAttribute('data-report-id');
            let sectionCheckboxEls = document.querySelectorAll(`input[id*='report-${reportId}-section-']`);
            if (checkboxEl.checked) {
                for (let sectionCheckboxEl of sectionCheckboxEls) {
                    sectionCheckboxEl.checked = true;
                }
            } else {
                for (let sectionCheckboxEl of sectionCheckboxEls) {
                    sectionCheckboxEl.checked = false;

                }
            }

        });
    }
}

function downloadButtonInit() {
    let downloadButton = document.querySelector("#download");

    if (downloadButton) {
        downloadButton.addEventListener('click', event => {
            // build our get link here
            let keysToBeDownloaded = getKeysToBeDownloaded();
            let getUrl = window.location.pathname + '/download';
            let arrStr = encodeURIComponent(JSON.stringify(keysToBeDownloaded));
            downloadButton.setAttribute('href', getUrl + '?keys=' + arrStr);
        });
    }
}

function getKeysToBeDownloaded() {
    let uploadKeyInputs = document.querySelectorAll("input[id$='-upload-keys']");
    let allKeysFromInputs = [];
    for (let uploadKeyInput of uploadKeyInputs) {
        if (uploadKeyInput.checked) {
            let keys = JSON.parse(uploadKeyInput.value);
            allKeysFromInputs.push(keys);
        }
    }
    allKeysFromInputs = allKeysFromInputs.flat();
    let downloadKeys = allKeysFromInputs.filter((key, index) => {
        return allKeysFromInputs.indexOf(key) === index;
    });
    return downloadKeys;
}

export default handleCollectiveDownloadPage;